var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumb2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cbed7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#62aac0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a8db0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.016,
    y1: 0.148,
    x2: 0.772,
    y2: 0.844,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "numb2",
    transform: "translate(-6.042 -6.042)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1117",
    "data-name": "\\uD0C0\\uC6D0 1117",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(6.042 6.042)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33861",
    "data-name": "\\uD328\\uC2A4 33861",
    d: "M188.6,143.239l-13.1-13.1a7.113,7.113,0,0,0-5.258-2.014c-4.159,0-6.676,2.539-6.676,6.379v.352l5.107,5.107c-1.271,1.578-3.019,3.661-5.413,6.485v1.156l9.184,9.184A19.057,19.057,0,0,0,188.6,143.239Z",
    transform: "translate(-145.284 -112.827)",
    opacity: 0.49,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33862",
    "data-name": "\\uD328\\uC2A4 33862",
    d: "M177.389,143.1v4.5H163.262v-1.156c7.642-9.014,8.695-10.47,8.695-12.1a1.6,1.6,0,0,0-1.651-1.721,1.663,1.663,0,0,0-1.716,1.863v.367h-5.021v-.351c0-3.841,2.517-6.379,6.676-6.379,4.029,0,6.811,2.477,6.811,6.043,0,2.39-.884,4.225-4.947,8.931Z",
    transform: "translate(-145.284 -112.827)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumb2);
export default __webpack_public_path__ + "static/media/numb2.8e6c46c0af33a917ece0e392c360f78d.svg";
export { ForwardRef as ReactComponent };